import { memo } from 'react';
import { shape, string } from 'prop-types';

import { EntityCard, Section, Title } from '~/elements';
import { dateUtils } from '~/routes/utils';

import styles from './BookingReview.scss';

export const BookingReview = ({ dateSlot, store }) => (
  <Section className={styles.BookingReviewSection} data-testid="BookingReviewSection">
    <Title className={styles.BookingReviewTitle} data-testid="BookingReviewTitle">
      Appointment summary
    </Title>
    <div className={styles.BookingReviewPanel}>
      <div className={styles.BookingReviewColumn}>
        <EntityCard title="Appointment date" data-testid="AppointmentDate">
          <div className={styles.EntityCardDescription}>
            {dateUtils.getTimeSlotFormattedDate(dateUtils.getDateFromString(dateSlot))}
          </div>
        </EntityCard>
      </div>
      <div className={styles.BookingReviewColumn}>
        <EntityCard title="Shop" data-testid="Shop">
          <div className={styles.EntityCardDescription}>{store.name}</div>
          <div className={styles.EntityCardDescription}>{store.address.addressLines}</div>
        </EntityCard>
      </div>
    </div>
  </Section>
);

BookingReview.propTypes = {
  dateSlot: string.isRequired,
  store: shape({
    id: string.isRequired,
    name: string.isRequired,
    address: shape({
      addressLines: string.isRequired,
    }),
  }).isRequired,
};

export const MemoizedBookingReview = memo(BookingReview);
